import BWDataService from 'src/services/bw-data.service';

export interface PlanUpdateDateCronPayload {
    year: Number;
    month: Number;
    day: Number;
    hour: Number;
    minute: Number;
    second: Number;
}

/**
 * TEST ONLY email functions. These use Phant debugging endpoints to trigger emails.
 * ONLY FOR USE in AdminUserForm.tsx!
 */
export default class TestOnlyEmailService extends BWDataService {
    public static async sendBudgetWelcomeEmail(): Promise<any> {
        const url: string = '/email/budget_welcome';
        return await this.post(url, '');
    }

    public static async sendBudgetAlertEmail(): Promise<any> {
        const url: string = '/email/budget?skipChecks=true';
        return await this.post(url, '');
    }

    public static async sendMonthlyBudgetEmail(): Promise<any> {
        const url: string = '/email/planupdate';
        return await this.post(url, '');
    }

    public static async executePlanUpdateCron(date: string): Promise<any> {
        const url: string = '/email/planupdate/cron';

        const dateRep: Date = new Date(date);

        const datePayload: PlanUpdateDateCronPayload = {
            year: dateRep.getFullYear(),
            month: dateRep.getMonth() + 1,
            day: dateRep.getDate(),
            hour: dateRep.getHours(),
            minute: dateRep.getMinutes(),
            second: dateRep.getSeconds()
        };

        return await this.post(url, datePayload);
    }
}
